module.exports = __webpack_public_path__ + "media/featured_internships/president-logo-d7ccdfe1.jpg";